import Service from "../../Service";
import Axios from "../../Config/API";
import { IGrupoProduto } from "../../../Interfaces/Geral/Grupos/GrupoProdutoInterfaces";

export const ListarProdutosVinculadosPorGrupoService = (idGrupo: number) =>
    Service(
        Axios.get<Array<IGrupoProduto>>(
            `/home/grupoproduto/listarprodutosvinculadosporgrupo?idGrupo=${idGrupo}`
        )
    );

export const ListarProdutosDesvinculadosPorGrupoService = (idGrupo: number) =>
    Service(
        Axios.get<Array<IGrupoProduto>>(
            `/home/grupoproduto/listarprodutosnaovinculadosporgrupo?idGrupo=${idGrupo}`
        )
    );

export const VincularProdutoGrupoService = (grupoProduto: IGrupoProduto[]) =>
    Service(
        Axios.post(`/home/grupoproduto/vincularprodutogrupo`, grupoProduto)
    );

export const DesvincularProdutoGrupoService = (idProdutoGrupo: number[]) =>
    Service(
        Axios.put(`/home/grupoproduto/desvincularprodutogrupo`, idProdutoGrupo)
    );
